import { LoadablePaint, MustPreloadLoadableNames } from '@confluence/loadable';

export const EmbeddedViewPageLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-view-pageEmbeddedViewPage" */ '../src/view-page/EmbeddedViewPage'
			)
		).EmbeddedViewPage,
	_mustPreloadWhenRenderingSPA: [MustPreloadLoadableNames.ViewPageRouteComponentLoader],
});
